<template>
	<ProcessCreatePage>
		<Header :title="title">
			<p>{{ $t('need_person_sign') }} <strong>Kunden</strong> {{ $t('damage_assessor_sign_customer') }}</p>
		</Header>

		<div class="main flex justify-around">
			<div class="flex flex-col">
				<BaseInput
					ref="BaseInput.damage"
					type="text"
					:label="$t('sign_location')"
					v-model="signLocation"
					@input="updateSignLocation"
					v-if="getAuthenticatedUserGroupLevel === '2'"
				/>
				<BaseSign ref="BaseSign" v-if="isShown && damageCase.signLocation" v-model="sign" />
			</div>
			<div>
				<PDFThumbnailPreview :pdf-u-r-l="pdfURL" :uuid="uuid" show-route-params="true" v-if="damageCase.signLocation" :type="pdfType" />
			</div>
		</div>

		<Footer
			@backButtonClick="$emit('previous', $event)"
			:disable-buttons="isLoading"
			@continueButtonClick="continueButtonClick(false)"
			@skipButtonClick="continueButtonClick(true)"
			:is-skippable="isSkippable"
		/>
	</ProcessCreatePage>
</template>

<script>
import Header from '../Header';
import Footer from '../Footer';
import BaseSign from '../../forms/inputs/BaseSign';
import { PdfApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import BaseInput from '@/components/forms/inputs/BaseInput';
import { PDFTypes } from '@/api/generated/models';
import PDFThumbnailPreview from '@/components/damagecases/forms/PDFThumbnailPreview';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';

export default {
	name: 'SignConsultant',
	components: { ProcessCreatePage, PDFThumbnailPreview, BaseInput, BaseSign, Footer, Header },
	data() {
		return {
			signLocation: '',
			sign: null,
			pdfURL: '',
			timeoutId: 0,
			uuid: '',
			isLoading: false,
		};
	},
	props: {
		isShown: { type: Boolean, default: false },
		damageCase: { required: true },
		title: {
			default: function() {
				return this.$t('generate_form_sign_customer');
			},
		},
		defaultCity: {
			type: String,
			required: true,
		},
	},
	methods: {
		updateSignLocation() {
			if (this.signLocation.trim() === '') {
				this.sign = null;
			}
		},
		continueButtonClick: function(isSkip) {
			this.isLoading = true;
			if (isSkip) {
				this.$emit('next', null);
				this.isLoading = false;
			} else if (this.sign || this.isSkippable) {
				this.$emit('next', { consultantSign: this.sign });
				this.isLoading = false;
			} else {
				this.isLoading = false;
				this.$swal(this.$t('general.attention').toString(), this.$t('sign_process').toString(), 'warning');
			}
		},
		getPDF() {
			clearTimeout(this.timeoutId);
			this.pdfURL = '';
			this.timeoutId = setTimeout(() => {
				PdfApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.pdfDamagecasesTypeTempSavePost(PDFTypes.DamageAccessor, {
						...this.damageCase,
						consultantSign: this.sign,
					})
					.then(res => {
						this.uuid = res.data.uuid;
						this.pdfURL = apiDefaults.axios.defaults.baseURL + 'api/pdf/damagecases/' + res.data.uuid + '/temp/file#toolbar=0&navpanes=0&scrollbar=0'; //not really used anymore
					});
			}, 400);
		},
	},
	computed: {
		isSkippable() {
			return this.defaultCity !== this.damageCase.signLocation;
		},
		getAuthenticatedUserGroupLevel() {
			return this.$store.getters.getAuthenticatedUserGroupLevel;
		},
		pdfType() {
			return PDFTypes.DamageAccessor;
		},
	},
	watch: {
		isShown: function() {
			if (this.isShown) {
				if (this.getAuthenticatedUserGroupLevel === '2') {
					if (this.signLocation && this.signLocation !== '') {
						this.getPDF();
					} else {
						this.damageCase.signLocation = '';
					}
				} else {
					this.getPDF();
				}
			}
		},
		sign() {
			this.getPDF();
		},
		signLocation: function() {
			this.damageCase.signLocation = this.signLocation;
			this.getPDF();
		},
	},
};
</script>

<style scoped></style>
